import { createSelector } from "reselect";
import { MEDIA_TYPE } from "app/constants";

const getFicheProduit = state => state.ficheProduit;
const getMultimediaPhotos = state => state.ficheProduit.multimedia;
const getPhotos = state => state.ficheProduit.photos;

export const getSpecialOffer = createSelector(
	[getFicheProduit],
	(ficheProduit = {}) => {
		return ficheProduit.specialOffer;
	}
);

export const getVideos = createSelector(
	[getMultimediaPhotos],
	(multimediaPhotos = []) => {
		const onlyVideo = multimediaPhotos.filter(media => {
			return media.type === MEDIA_TYPE.VIDEO;
		});
		return onlyVideo;
	}
);

export const getDesktopSlideShowPhotos = createSelector(
	[getPhotos, getVideos],
	(photos = [], videos = []) => {
		const photosBeforeVideos = photos.length > 0 ? [photos[0]] : [];

		return photosBeforeVideos.concat(videos).concat(photos.slice(1, photos.length));
	}
);

export const getProductCountry = createSelector(
	[getFicheProduit],
	(ficheProduit = {}) => {
		return ficheProduit.country;
	}
);

export const getCurrentProductURI = createSelector(
	[getFicheProduit],
	(ficheProduit = {}) => {
		return ficheProduit.uri;
	}
);

export const isProductExpired = createSelector(
	[getFicheProduit],
	(ficheProduit = {}) => {
		return ficheProduit.expiration?.hour === 0 && ficheProduit.expiration?.day === 0;
	}
);
